import clsx from "clsx";
import Button from "@/components/elements/Button";

import SocialLink from "@/components/elements/SocialLink";
import * as styles from "./styles.module.scss";

export function SearchAndSocials({
  socials_menu,
  onSearchClick,
  className,
}: {
  socials_menu: HeaderTemplate["socials_menu"];
  onSearchClick: () => void;
  className?: string;
}) {
  return (
    <div className={clsx([styles.socialsContainer, className])}>
      <Button variant="outlined" onClick={onSearchClick}>
        <img src="/svgs/search.svg" alt="search" data-svg="true" />
      </Button>
      {socials_menu &&
        socials_menu?.length > 0 &&
        socials_menu.map((social) => (
          <SocialLink key={social.url} {...social} />
        ))}
    </div>
  );
}
